import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { EndCustomerService } from 'src/app/services/end-customer.service';

import { CategoryService } from 'src/app/services/shared/product-settings/category.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-company-product-categories',
  templateUrl: './company-product-categories.component.html',
  styleUrls: ['./company-product-categories.component.scss']
})
export class CompanyProductCategoriesComponent implements OnInit {
  @Input() productCategoriesForm!: FormArray;
  @Input() existedSelectedIds: any[] =[];
  @Output() categoriesChange = new EventEmitter<any[]>();
  categories: any[] = [];
  selectControl = new FormControl();
  selectedCategories: any[] = []; 
  noRecordsFoundData: boolean = false;
  isCategoryInputFieldClicked: boolean = false;
  filteredCategory: any[] = [];

  constructor(private endCustomerService: EndCustomerService,private categoryService: CategoryService,) {}

  ngOnInit(): void {
    this.getCategories();
    this.selectControl.valueChanges.subscribe(value => {
      this.onSelectionChange(value);
    });
  }

  getCategories() {
    
    this.categoryService.getLastNodeCategory().subscribe(data => {
      if (data && data?.data && data?.data?.length > 0) {
        this.categories = data?.data;
        this.filteredCategory = this.categories;
        this.mapSelectedCategories();
      }
    }, error => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      })
    });
  }

  getCategory(id: any) {
    return this.categories.find((obj: any) => obj?.id === id)?.name;
  }

  remove(index: number): void {
    const removedValue = this.productCategoriesForm.at(index).value;
    this.productCategoriesForm.removeAt(index);
    const currentSelectedValues = this.selectControl.value.filter((id: any) => id !== removedValue);
    this.selectControl.setValue(currentSelectedValues);
    this.emitChanges();
  }
  
  onSelectionChange(selectedIds: any[]) {
    this.productCategoriesForm?.clear();
    selectedIds?.forEach((id: any) => this.productCategoriesForm?.push(new FormControl(id)));
    this.emitChanges();
  }

  emitChanges() {
    this.categoriesChange.emit([this.productCategoriesForm?.value,this.existedSelectedIds]);
  }

  mapSelectedCategories() {
    const selectedIds = this.existedSelectedIds;
    this.selectControl?.setValue(selectedIds);
  }

  keyDownButton(category: any, event: any) {
    const categoryIds = this.productCategoriesForm?.value || [];
    const index = categoryIds.indexOf(category?.id);

    if (index > -1) {
      categoryIds.splice(index, 1);
      } else {
        categoryIds.push(category?.id);
      }

      this.selectControl.setValue(categoryIds);
    }
  
  filterCategory(event: any) {
    this.isCategoryInputFieldClicked = true;
    const searchText = event.target.value.toLowerCase();
    this.filteredCategory = this.categories?.filter(category =>
      category.name.toLowerCase().includes(searchText)
    );
    this.noRecordsFoundData = this.filteredCategory.length === 0;
  }

  // Track category input field clicks
  categoryInputFieldClicked() {
    this.isCategoryInputFieldClicked = true;
    this.filteredCategory = [...this.categories]; // Reset dropdown data
    this.noRecordsFoundData = this.filteredCategory.length === 0;
  }

  // Check if category is selected (for checkbox state)selectedCategories: number[] = []; // Store selected category IDs
toggleCheckbox(category: any, event?: Event) {
  if (event) {
    event.stopPropagation(); // Prevents event from bubbling up
  }

  const index = this.productCategoriesForm?.controls.findIndex(
    (control) => control.value === category?.id
  );

  if (index !== -1) {
    // Remove the selected category
    this.productCategoriesForm.removeAt(index);
  } else {
    // Add the selected category
    this.productCategoriesForm.push(new FormControl(category?.id));
  }
}

isSelected(categoryId: number): boolean {
  return this.productCategoriesForm.value.includes(categoryId);
}

  
  
  
  checkBoxClicked(category: any) {
    if (this.productCategoriesForm) {
      const index = this.productCategoriesForm.controls.findIndex(
        (control) => control.value === category.id
      );
    
      if (index !== -1) {
        // Remove the selected category
        this.productCategoriesForm.removeAt(index);
      } else {
        // Add the selected category
        this.productCategoriesForm.push(new FormControl(category.id));
      }
    }
    
    
  }

}

